export const enableScroll = (): void => document.documentElement.setAttribute('data-modal-active', 'false');

export const disableScroll = (): void => document.documentElement.setAttribute('data-modal-active', 'true');
